module.exports = __webpack_public_path__ + "static/media/icCheckGreen.78d04af8.svg";